import React from 'react';
import { FaArrowRight } from "react-icons/fa";
import { Controller } from 'react-hook-form';
import 'stylesheets/comman/inputBox.scss';

const RadioGroup = ({ rows, name, control, options, rules, label, subText, onSubText, defaultValue, onChange }) => {
  return (
    <div className="form-group">
      {label && <label className="title">{label}</label>}
      {subText && <span onClick={onSubText} className='subLabel'>{subText} <FaArrowRight /></span>}
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => (
          <div className={`radioWrap ${rows ? 'rows' : null}`}>
            {options.map((opt, idx) => (
              <label key={idx}>
                <input
                  type="radio"
                  value={opt.value}
                  checked={field.value === opt.value}
                  onChange={(e) => {
                    field.onChange(e);
                    if (onChange) onChange(e.target.value);
                  }}
                />
                <span>{opt.label}</span>
              </label>
            ))}
            {fieldState.error && (
              <span className='error'>
                {fieldState.error.message}
              </span>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default RadioGroup;